import React from 'react';
// import './index.scss';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

const CardDiv = styled.div`
  height: 270px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #ffffff;
  cursor: pointer;
  position: relative;
  .left {
    flex: 1;
    img {
      display: block;
      height: 270px;
      width: 100%;
    }
  }

  .right {
    padding: 32px;
    width: 50%;
    flex: 1;
    .title {
      font-weight: 700;
      font-size: 20px;
      color: #222222;
      line-height: 26px;
      text-align: left;
    }

    .content {
      margin-top: 6px;
      font-size: 14px;
      color: #555555;
      line-height: 22px;
      height: 66px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    .time {
      position: absolute;
      bottom: 32px;
      font-size: 14px;
      color: #555555;
      line-height: 22px;
      text-align: left;
    }
  }
`;

export const NewsCard = (props) => {
  const { img, title, desc, time, key } = props;
  return (
    <CardDiv className='news-card' onClick={props.onClick}>
      <div className='left'>
        <img src={img} alt='' />
      </div>
      <div className={'right'}>
        <div className='title ' style={{ textAlign: 'left', width: '100%' }}>
          {title}
        </div>
        <div className='content'>{desc}</div>
        <div className='time'>{time}</div>
      </div>
    </CardDiv>
  );
};
